import { AnyAction } from "@reduxjs/toolkit";
import {
    RATE_UPDATE_SAGA,
    RATE_UPDATE_SUCCESS,
    RATE_UPDATE_FAILURE,
} from "@/Redux/Rate/RateConstants";
import { RootStateOrAny } from "react-redux";

interface AppState {
    isLoadingRates: any;
}

const initialState: AppState = {
    isLoadingRates: false,
};

export default function RateReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case RATE_UPDATE_SAGA:
            return {
                ...state,
                isLoadingRates: true,
            };
        case RATE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoadingRates: false,
                rates: {
                    data: action.data.rateList?.rates,
                },
            };
        case RATE_UPDATE_FAILURE:
            return {
                ...state,
                isLoadingRates: false,
            };
        default:
            return state;
    }
}
